import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import LazyImage from "./LazyImage";

const SpiceGoldModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="modal-md d-flex align-items-center" // Switched to 'modal-md' for a smaller overall footprint
    >
      {/* Apply a dark, themed background to the modal content */}
      <div className="bg-light text-white rounded-3 shadow-lg w-100">
        <Modal.Header
          closeButton
          // Reduced top/bottom padding
          className="border-bottom-0 p-3 pb-1"
          closeVariant="white"
          style={{ color: "white" }}
        >
          {/* Reduced font size for the title */}
          <Modal.Title className="fw-bolder fs-4">
            How to Earn Points{" "}
            <LazyImage
              src={"/assets/images/spicegold.png"}
              alt="SpiceGold Icon"
              style={{ height: "30px", width: "30px" }}
            />{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="p-3 pt-0"
          style={{
            color: "white",
            lineHeight: "1.4",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          {/* Introduction Section - Reduced margin */}
          <p className="small">
            Join the <strong className="text-warning">IceSpice </strong> and
            start stacking those rewards!
          </p>

          {/* Earning Methods - Switched to a single-column, compact list with reduced spacing */}
          <div className="d-grid gap-2 mb-3">
            {/* Play Games */}
            <div className="d-flex align-items-center p-2 bg-black bg-opacity-25 rounded-3">
              <span className="fs-5 me-2 text-danger">🔥</span>
              <strong className="me-1">Play Games</strong>
              <small className="text-light">
                Earn SpiceGold from daily matches & tournaments.
              </small>
            </div>
            {/* Refer Friends */}
            <div className="d-flex align-items-center p-2 bg-black bg-opacity-25 rounded-3">
              <span className="fs-5 me-2 text-info">👯</span>
              <strong className="me-1">Refer Friends</strong>
              <small className="text-light">
                Share referral code - Both get bonus SpiceGold!
              </small>
            </div>
            {/* Special Events */}
            <div className="d-flex align-items-center p-2 bg-black bg-opacity-25 rounded-3">
              <span className="fs-5 me-2 text-warning">🎊</span>
              <strong className="me-1">Special Events</strong>
              <small className="text-light">
                Limited-time events for massive boosts.
              </small>
            </div>
            {/* MVP Bonus */}
            <div className="d-flex align-items-center p-2 bg-black bg-opacity-25 rounded-3">
              <span className="fs-5 me-2 text-primary">🏅</span>
              <strong className="me-1">MVP Bonus</strong>
              <small className="text-light">
                Be the MVP in FBL for extra points!
              </small>
            </div>
            {/* Bharat Pass - Highlighted and compact */}
            <div className="d-flex align-items-center p-2 bg-primary bg-opacity-50 rounded-3 border border-warning">
              <span className="fs-5 me-2 text-warning">💳</span>
              <strong className="me-1">Bharat Pass</strong>
              <small className="text-light">
                <strong className="text-warning">5x multiplier</strong> on all
                points!
              </small>
            </div>
          </div>

          {/* Call to Action - Smaller font and reduced margin */}
          <div className="text-center p-2 mb-3 bg-dark border border-secondary rounded-3">
            <p className="mb-0 small text-warning">
              Redeem SpiceGold for products, gift vouchers & more.
              <br />
              <strong className="text-white">
                Keep playing, keep earning!
              </strong>
            </p>
          </div>

          {/* Earn SpiceGold Banner/Table - This is the main size reduction area */}
          <h6 className="text-center fw-bold mb-2 text-warning">
            SPICE GOLD LIMITS WITH BHARATPASS
          </h6>
          <div className="text-center p-1 border border-secondary rounded-3">
            {/* The image is now constrained to a maximum width to fit the 'modal-md' size */}
            <LazyImage
              src="https://appcdn.goqii.com/storeimg/20340_1760701717.jpeg"
              alt="SpiceGold Earning Table"
              className="img-fluid rounded"
              style={{
                // Keep max width at 100% of the container, the container is smaller now
                maxWidth: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>
        </Modal.Body>

        <Modal.Footer
          // Reduced padding and removed top border
          className="border-top-0 p-2 pt-0 justify-content-center"
        >
          <Button
            variant="primary"
            className="fw-bold px-3 py-1" // Smaller button padding
            onClick={onHide}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default SpiceGoldModal;
